import React from 'react';
import Slider from 'react-slick';
import '../style/HeroBanner.css';
import hero1 from '../assets/hero1.png';
import hero2 from '../assets/asusad.png';
import hero3 from '../assets/lakmead.webp';
import zouk from '../assets/zoukad.png';
import ayurveda from "../assets/ayurveda.webp";

// banners array
const banners = [
     {
    id: 1,
    image: zouk,
    alt: 'zouk ad',
    link: 'https://zouk.co.in/collections/satchel-bag-collection?ref=homepage_Slider/&utm_source=we24seven&utm_medium=we24seven01'
  },
  {
    id: 2,
    image: hero2,
    alt: 'Asus Deals',
    link: 'https://in.store.asus.com/everyday-laptops-asus-vivobook-16-x1605va-mb1627ws.html/?utm_source=we24seven&utm_medium=we24seven01'
  },
  {
    id: 3,
    image: hero3,
    alt: 'lakme India',
    link: 'https://www.lakmeindia.com/pages/sale?srsltid=AfmBOor_ICAx4rjfv8GS1qr5XQjGF_ML7b5EaxatVivha6Uls8pkiBNX/&utm_source=we24seven&utm_medium=we24seven01'
  },
 {
    id: 4,
    image: hero1,
    alt: 'H&M Offer',
    link: 'https://click.linksynergy.com/deeplink?id=Sd2aiOckzgQ&mid=46922&murl=https%3A%2F%2Fwww2.hm.com%2Fen_in%2Findex.html%3Futm_source%3Dwe24seven%26utm_medium%3Dwe24seven01'
  },
  {
     id: 5,
    image: ayurveda,
    alt: 'Luxury Ayurveda Offer',
    link: 'https://www.kamaayurveda.in/bringaras-collection.html?utm_source=we24seven&utm_medium=we24seven01'
  
  }
];

// custom arrow components
const NextArrow = ({ onClick }) => (
  <div className="arrow next" onClick={onClick}>
    ❯
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="arrow prev" onClick={onClick}>
    ❮
  </div>
);

const HeroBanner = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  };

  return (
    <section className="hero-carousel">
      <Slider {...settings}>
        {banners.map((banner) => (
          <div key={banner.id} className="carousel-slide">
            <a href={banner.link} target="_blank" rel="noopener noreferrer">
              <img src={banner.image} alt={banner.alt} />
            </a>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default HeroBanner;
